module.exports = __webpack_public_path__ + "media/images/home/logo_ana-6b24fa19306f591386431c1c44e3e118.png";